<template>
  <mdb-container class="gp-has-header">

    <data-table v-show="!showEditor" ref="storeList" :add-handler="create"
                :click-handler="editVideo"
                :columns="columns"
                add-label="New Video"
                data-source="/video/list"
                page-title="Ezumee Videos"
                show-add-button/>

    <div v-if="showEditor" class="text-left">
      <mdb-btn rounded size="sm" @click="showList">
        <mdb-icon icon="arrow-left"/>
        Back to List
      </mdb-btn>
      <mdb-card>
        <mdb-card-header>
          <h3>Video Details</h3>
        </mdb-card-header>
        <mdb-card-body>
          <div>
            <mdb-input id="videoName" v-model="currentVideo.name" label="Name"/>
          </div>
          <div>
            <label>Tags</label>
            <cust-chip-input :chips="currentVideo.tags"/>
          </div>
          <mdb-tbl responsive striped>
            <mdb-tbl-head class="secondary-color">
              <tr>
                <th>CDN File Path</th>
                <th>Type</th>
                <td>&nbsp;</td>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="(file,i) in this.currentVideo.files" :key="i">
                <td>
                  <mdb-input v-model="file.url" placeholder="Full Path & Name"/>
                </td>
                <td>
                  <select id="file-type" v-model="file.type" class="browser-default custom-select">
                    <option value="video/webm">webm</option>
                    <option value="video/mp4">mp4</option>
                  </select>
                </td>
                <td>
                  <mdb-btn color="danger" floating icon="trash" size="sm" tag="a" @click="deleteFile(file)"/>
                  <mdb-btn floating icon="play" size="sm" tag="a" @click="testPlay(file)"/>
                </td>

              </tr>
            </mdb-tbl-body>

          </mdb-tbl>
          <mdb-btn icon="plus-circle" rounded size="sm" @click="addFile">Add File</mdb-btn>
        </mdb-card-body>
        <mdb-card-footer>
          <mdb-btn :disabled="!currentVideo.name" icon="save"
                   @click="save">Save
          </mdb-btn>
        </mdb-card-footer>
      </mdb-card>

    </div>

    <yes-no-modal v-if="deleteModal" @no="deleteModal=false" @yes="doDeleteFile"/>
    <mdb-modal v-if="showPlayer" class="text-center" size="lg" @close="showPlayer = false">
      <mdb-modal-header :close="true" center class="secondary-color">
        <p class="heading">Test Video</p>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <video id="ez-video-container" width="100%" autoplay controls>
          <source :src="settings.videoUrl + testFile.url" :type="testFile.type">
          Your browser does not support the video tag.
        </video>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import error from '../common/Error'
import dataTable from "../common/DataTable";
import {custChipInput} from "../common/CustChipInput";
import YesNoModal from "../common/YesNoModal";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';
import Vue from "vue";

export default {
  name: "video-admin",
  display: "Video Admin",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileInput,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    custChipInput,
    error,
    dataTable,
    YesNoModal
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      videos: [],
      showConfirm: false,
      deleteModal: false,
      testFile: null,
      showPlayer: false,
      currentVideo: {
        id: null, name: "", tags: [], files: []
      },
      showEditor: false,
      showViewer: false,
      columns: [
        {label: "ID", field: "id"},
        {label: "Name", field: "name"}
      ]

    }
  },
  methods: {
    create: function () {
      this.currentVideo = {
        id: null, name: "", tags: [], files: []
      }
      this.showEditor = true
      Vue.nextTick().then(() => {
        document.getElementById("videoName").focus()
      })

    },
    save: function () {
      this.$store.dispatch("setExecuting", true)

      api.post("/video/edit/", this.currentVideo).then(
        (details) => {
          if (!this.currentVideo.id) {
            this.currentVideo = details.data
          }
          this.$notify.success({message: "Video saved successfully."})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editVideo: function (video) {
      this.currentVideo = video
      this.showEditor = true
    },
    showList: function () {
      this.showEditor = false
      this.$store.dispatch("setDataTableReload", true)
    },
    addFile: function () {
      let file = {id: null, url: "", type: "video/webm"}
      this.currentVideo.files.push(file)
    },
    deleteFile: function (f) {
      this.deleteCandidate = f
      this.deleteModal = true
    },
    doDeleteFile: function () {
      this.deleteModal = false
      let loc = this.currentVideo.files.indexOf(this.deleteCandidate)
      this.deleteCandidate = null
      this.currentVideo.files.splice(loc, 1)
    },
    testPlay: function(f) {
      this.testFile = f
      this.showPlayer = true
    }

  }
}
;
</script>
